module.exports = __webpack_public_path__ + "static/media/coin.98039330.svg";